<script setup lang="ts">
import { ActionButton } from '@taler/ui'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSession } from '@/app/session'

const { t } = useI18n()
const session = useSession()
</script>

<template>
  <main class="mx-auto flex w-full max-w-[92.5rem] flex-col gap-6 p-[var(--space-page)]">
    <h1 class="text-[length:var(--text-step-6)] font-semibold text-[color:var(--color-text)]">
      {{ t('app.foundation') }}
    </h1>
    <p class="text-[length:var(--text-step-3)] text-[color:var(--color-text-muted)]">
      {{ t('app.foundationBody') }}
    </p>

    <p v-if="session.isLoading.value" role="status">{{ t('app.loading') }}</p>

    <section
      v-else-if="session.principal.value"
      aria-labelledby="session-heading"
      class="flex flex-col gap-3"
    >
      <h2 id="session-heading" class="text-[length:var(--text-step-4)] font-medium">
        {{ t('app.signedInAs') }}
      </h2>
      <p class="figure text-[color:var(--color-text)]">{{ session.principal.value.subject }}</p>

      <h2 class="text-[length:var(--text-step-4)] font-medium">{{ t('app.ledgers') }}</h2>
      <ul class="flex flex-col gap-1">
        <li v-for="ledger in session.ledgers.value" :key="ledger.id">
          <button
            type="button"
            class="min-h-[var(--density-target-min)] w-full rounded-[var(--radius-control)] border border-[color:var(--color-border-control)] px-3 py-2 text-left"
            :aria-current="session.activeLedger.value?.id === ledger.id ? 'true' : undefined"
            @click="session.selectLedger(ledger.id)"
          >
            <span>{{ ledger.name }}</span>
            <span class="ml-2 text-[color:var(--color-text-muted)]"
              >{{ t('app.role') }}: {{ ledger.role }}</span
            >
            <span v-if="ledger.archivedAt" class="ml-2 text-[color:var(--color-attention)]">
              {{ t('app.archived') }}
            </span>
          </button>
        </li>
      </ul>

      <ActionButton :as="RouterLink" to="/transactions" class="w-fit">
        {{ t('transactions.title') }}
      </ActionButton>
    </section>
  </main>
</template>
